<template>
  <div class="cylinder-specification-container">
    <CylinderSpecification />
  </div>
</template>

<script setup lang="ts">
import CylinderSpecification from './CylinderSpecification.vue'
import {useHydraulicSelectorStore} from '@/store/hydraulic-selector'
import {onMounted} from 'vue'

const hydraulicSelectorStore = useHydraulicSelectorStore()

onMounted(() => {
  hydraulicSelectorStore.loadDefaultData()
})
</script>
<style lang="scss">
.cylinder-specification-container {
  width: 100%;
}
</style>

<script lang="ts">
export default defineComponent({
  name: 'HydraulicSelectorBase',
  data() {
    return {
      showPopup: false
    }
  }
})
</script>
